/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * 1 = Bug
 * 2 = Question
 * 3 = Idea
 */
export enum PlatformFeedbackType {
  Bug = 1,
  Question = 2,
  Idea = 3
}
